import { GraphQLQueryClass } from "@harea/component";
import { THolidaysResponse } from "@harea/component";

export class OffDayListQuery
    implements GraphQLQueryClass<THolidaysResponse, TResponse>
{
    queryKey: string = "Harea.Vacation.OffDay.List.Query";

    gql: string = `
        query offDayListQuery($pageSize: Float, $page: Float, $data: JSONObject) {
            holidays(
                filter: {
                    pageSize: $pageSize,
                    page: $page
                    data: $data,
                }
            ) {
                total
                data {
                    id
                    year
                    holidayType
                    name
                    value
                    startDate
                    endDate
                    comment
                    allowCriticalLeaveOnly
                    translationKey
                    personnelGroup {
                        id
                    }
                }
            }
        }
    `;

    variables?: any;

    constructor(variables?: any) {
        this.variables = variables;
    }

    mapFn(data: TResponse): THolidaysResponse {
        return data.holidays;
    }
}

type TResponse = {
    holidays: THolidaysResponse
}